var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 123,
    viewBox: "0 0 179 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 42,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20831 -2.00272e-05C3.22726 -2.00272e-05 -2.00272e-05 3.22726 -2.00272e-05 7.20831C-2.00272e-05 11.1894 3.22726 14.4166 7.20831 14.4166H30.1331L36.1278 44.3678C36.1597 44.573 36.2003 44.7752 36.2492 44.9742L48.2898 105.132L48.2907 105.137C49.2803 110.113 51.9879 114.583 55.9401 117.764C59.8737 120.931 64.7909 122.621 69.8385 122.542H139.78C144.827 122.621 149.745 120.931 153.678 117.764C157.632 114.582 160.34 110.11 161.329 105.132L161.339 105.078L168.847 65.7058C167.593 65.8995 166.308 66 165 66C161.269 66 157.73 65.1829 154.55 63.7179L147.188 102.324L147.184 102.346C146.85 103.997 145.95 105.478 144.638 106.534C143.32 107.595 141.671 108.159 139.98 108.126C139.934 108.125 139.888 108.125 139.842 108.125H69.7766C69.7306 108.125 69.6846 108.125 69.6385 108.126C67.9471 108.159 66.2981 107.595 64.9803 106.534C63.6625 105.474 62.7598 103.983 62.4302 102.324L62.4281 102.313L52.0494 50.4583H141.851C140.658 47.5407 140 44.3471 140 41C140 39.3024 140.169 37.6443 140.492 36.0416H49.1639L43.1098 5.79363C42.4355 2.42476 39.4773 -2.00272e-05 36.0416 -2.00272e-05H7.20831Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.01d70d4936df37c102f2df295deffbbd.svg";
export { ForwardRef as ReactComponent };